import { css } from '@emotion/css';
import c from 'classnames';

// sometimes in safari line-clamp doesn't work, so we need to use max-height
// max-height = line-height * number-of-lines
// ref: https://github.com/CezaryDanielNowak/React-dotdotdot/blob/master/src/clamp.js
// 1.2em is a fallback if --typography-line-height isn't set
// --typography-line-height is set in packages/style/src/tailwind_extension.css
const lineClamp = (clamp: number) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${clamp};
  -webkit-box-orient: vertical;
  max-height: calc(var(--typography-line-height, 1.2em) * ${clamp});
  overflow-wrap: anywhere;
`;

export const truncate = (clamp: number) => c('text-ellipsis overflow-hidden', lineClamp(clamp));
